module.exports = __webpack_public_path__ + "static/lp-lk-img-2-9c72c624dfb6687e693fc1425156738d.png";